import { createContext } from 'react';

export type SummaryGenerationStatusValue =
  | 'PENDING'
  | 'IN_PROGRESS'
  | 'COMPLETED'
  | 'FAILED';

export interface SummaryGenerationStatus {
  enps: {
    status: SummaryGenerationStatusValue;
    backgroundTaskKey: string | null;
    errorMessage: string | null;
  };
  engagement: {
    status: SummaryGenerationStatusValue;
    backgroundTaskKey: string | null;
    errorMessage: string | null;
  };
}

export const createInitialSummaryGenerationStatus =
  (): SummaryGenerationStatus => ({
    enps: {
      status: 'PENDING',
      backgroundTaskKey: null,
      errorMessage: null,
    },
    engagement: {
      status: 'PENDING',
      backgroundTaskKey: null,
      errorMessage: null,
    },
  });

// Data types for shared summary data
export interface EnpsSummaryData {
  summary?: Record<string, unknown>;
  background_task_key?: string;
}

export interface EngagementSummaryData {
  question_summaries?: unknown[];
  background_task_key?: string;
}

export interface SummaryStatusContextValue {
  summaryStatus: SummaryGenerationStatus;
  setSummaryStatus: (
    status:
      | SummaryGenerationStatus
      | ((prev: SummaryGenerationStatus) => SummaryGenerationStatus)
  ) => void;
  // Shared summary data to avoid duplicate API calls
  enpsData: EnpsSummaryData | null;
  engagementData: EngagementSummaryData | null;
  setEnpsData: (data: EnpsSummaryData | null) => void;
  setEngagementData: (data: EngagementSummaryData | null) => void;
}

export const SummaryStatusContext =
  createContext<SummaryStatusContextValue | null>(null);
